import { render, staticRenderFns } from "./FaqAccordion.vue?vue&type=template&id=1e3d7e9a&"
import script from "./FaqAccordion.vue?vue&type=script&lang=js&"
export * from "./FaqAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FaqAccordion.vue?vue&type=style&index=0&lang=sass&rel=stylesheet%2Fsass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports